var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VideoSlide',{attrs:{"src":require('@/assets/videos/2600_KMSAT45_2022_YRConclusion.mp4'),"vtt":require('@/assets/videos/2600_KMSAT45_2022_YRConclusion.vtt'),"background-theme":"dark"}})}
var staticRenderFns = []

export { render, staticRenderFns }